import { Draft, produce } from 'immer';

import {
    CHANGE_TARGET_PLATFORM,
    INIT_TARGET_TAGS_EDITORS,
    RESET_TARGET_TAGS_EDITORS,
    TargetTagsEditorAction,
    UPDATE_TARGET_TAGS_EDITOR_VALIDATION
} from '../actions/targetTagsEditor';
import { TargetTagsEditorsState } from '../typings/state';
import { TargetTagsEditorState } from '../typings/targetTagsEditor';

export const DEFAULT_TARGET_TAGS_EDITORS_STATE: TargetTagsEditorsState = {};
export const EMPTY_TARGET_TAGS_EDITOR: TargetTagsEditorState = {
    platforms: {},
    errors: []
};

export function targetTagsEditor(
    state: TargetTagsEditorsState = DEFAULT_TARGET_TAGS_EDITORS_STATE,
    action: TargetTagsEditorAction
): TargetTagsEditorsState {
    return produce(state, (draft: Draft<TargetTagsEditorsState>) => {
        switch (action.type) {
            case INIT_TARGET_TAGS_EDITORS: {
                draft = action.editors;

                break;
            }

            case CHANGE_TARGET_PLATFORM: {
                const { editorId, platform } = action;
                const editorState: TargetTagsEditorState = draft[editorId];
                editorState.platforms[platform.tag] = platform;

                draft[editorId] = editorState;

                break;
            }

            case UPDATE_TARGET_TAGS_EDITOR_VALIDATION: {
                const { editorId, errors } = action;

                draft[editorId].errors = errors;

                break;
            }

            case RESET_TARGET_TAGS_EDITORS: {
                if (action.editorIds && action.editorIds.length) {
                    action.editorIds.forEach(editorId => {
                        delete draft[editorId];
                    });
                } else {
                    draft = DEFAULT_TARGET_TAGS_EDITORS_STATE;
                }

                break;
            }

            default:
        }

        return draft;
    });
}
